import { LoaderCircle, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import shopApi from "../../../../api/shopApi";
import { useNotification } from "../../../../hooks/useNotification";
import AddFriendModal from "../AddFriendModal";

export default function ContactModal({
  isOpen,
  setIsOpen,
  user,
  staffs,
  shop,
  setNewContact,
}) {
  const { addNotification } = useNotification();
  const [showProfile, setShowProfile] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [contact, setContact] = useState(null);
  const [isOpenAddFriendModal, setIsOpenAddFriendModal] = useState(false);
  const phoneInpRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSearch = async () => {
    try {
      if (!phoneNumber?.trim()) {
        addNotification("Vui lòng nhập số điện thoại", -1);
        return;
      }
      setIsLoading(true);
      const res = await shopApi.searchContact({
        shopId: shop._id,
        phone: phoneNumber,
      });
      if (res.status === 1) {
        setContact(res.data);
        setShowProfile(true);
      } else addNotification(res.message, res.status);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      addNotification("Có lôi xảy ra: " + error.message, -1);
    }
  };

  const handleAddFriendClick = async (contentAddFriend) => {
    try {
      if (!contact) return;
      const checkExist = await shopApi.getContactByUid(
        shop._id,
        contact.userId,
      );
      if (checkExist.status === -1) {
        const res = await shopApi.createContacts({
          staffIds: [user._id],
          shopId: shop._id,
          uid: contact.userId,
          name: contact.displayName,
          zaloName: contact.zaloName,
          avatar: contact.avatar,
          gender: contact.gender,
          sdob: contact.sdob,
          bio: contact.status,
          phone: contact.phoneNumber,
          isFriend: contact.isFr === 1,
          isSearchPhone: true,
          staffName: user.name,
        });
        if (res.status === 1) {
          setNewContact(res.data);
          setPhoneNumber("");
          setShowProfile(false);
          setIsOpen(false);
        } else {
          addNotification("Có lỗi xảy ra: " + res.message, res.status);
        }
      } else {
        const shopRole = user.shopRoles?.find((sr) => sr.shopId === shop._id);
        const viewableStaffIds = shopRole?.viewMoreStaffIds ?? [];
        if (
          !user?.role?.includes("admin") &&
          user?._id !== shop?.staffId &&
          shopRole?.role !== "admin" &&
          checkExist.data[0]?.staffIds?.length > 0 &&
          !checkExist.data[0]?.staffIds?.includes(user._id) &&
          !checkExist.data[0]?.staffIds?.some((sId) =>
            viewableStaffIds.includes(sId),
          )
        ) {
          addNotification(
            `${checkExist.data[0]?.name} đang do ${
              staffs?.find((s) => s._id === checkExist.data[0]?.staffIds[0])
                ?.name
            } quản lý`,
            -1,
          );
          return;
        }
        if ((checkExist.data[0]?.staffIds?.length ?? 0) === 0) {
          const resUpdate = await shopApi.updateContact({
            _id: checkExist.data[0]._id,
            staffIds: [user._id],
            isSearchPhone: true,
            staffName: user.name,
            phone: contact.phoneNumber,
            shopId: shop._id,
          });
          setNewContact(resUpdate.data);
        } else {
          // Trigger search log even if assigned
          shopApi
            .updateContact({
              _id: checkExist.data[0]._id,
              isSearchPhone: true,
              staffName: user.name,
              phone: contact.phoneNumber,
              shopId: shop._id,
            })
            .catch(() => {});
          setNewContact(checkExist.data[0]);
        }
        setPhoneNumber("");
        setShowProfile(false);
        setIsOpen(false);
      }
      const resAddFriend = await shopApi.addFriend({
        uid: contact.userId,
        contentAddFriend: contentAddFriend,
        shopId: shop._id,
        zaloId: shop.zaloId,
        staffId: user?._id,
      });
      if (resAddFriend.status !== 1) {
        addNotification(resAddFriend.message, resAddFriend.status);
        return;
      }
      addNotification("Gửi lời mời kết bạn thành công", resAddFriend.status);
    } catch (error) {
      addNotification("Có lôi xảy ra: " + error.message, -1);
    }
  };

  const handleMessageClick = async () => {
    try {
      if (!contact) return;
      const checkExist = await shopApi.getContactByUid(
        shop._id,
        contact.userId,
      );
      if (checkExist.status === -1) {
        const res = await shopApi.createContacts({
          staffIds: [user._id],
          shopId: shop._id,
          uid: contact.userId,
          name: contact.displayName,
          zaloName: contact.zaloName,
          avatar: contact.avatar,
          gender: contact.gender,
          sdob: contact.sdob,
          bio: contact.status,
          phone: contact.phoneNumber,
          isFriend: contact.isFr === 1,
        });
        if (res.status === 1) {
          setNewContact(res.data);
          setPhoneNumber("");
          setShowProfile(false);
          setIsOpen(false);
        } else {
          addNotification("Có lỗi xảy ra: " + res.message, res.status);
        }
      } else {
        const shopRole = user.shopRoles?.find((sr) => sr.shopId === shop._id);
        const viewableStaffIds = shopRole?.viewMoreStaffIds ?? [];
        if (
          !user?.role?.includes("admin") &&
          user?._id !== shop?.staffId &&
          shopRole?.role !== "admin" &&
          checkExist.data[0]?.staffIds?.length > 0 &&
          !checkExist.data[0]?.staffIds?.includes(user._id) &&
          !checkExist.data[0]?.staffIds?.some((sId) =>
            viewableStaffIds.includes(sId),
          )
        ) {
          addNotification(
            `${checkExist.data[0]?.name} đang do ${
              staffs?.find((s) => s._id === checkExist.data[0]?.staffIds[0])
                ?.name
            } quản lý`,
            -1,
          );
          return;
        }
        if ((checkExist.data[0]?.staffIds?.length ?? 0) === 0) {
          const resUpdate = await shopApi.updateContact({
            _id: checkExist.data[0]._id,
            staffIds: [user._id],
            isSearchPhone: true,
            staffName: user.name,
            phone: contact.phoneNumber,
            shopId: shop._id,
          });
          setNewContact(resUpdate.data);
        } else {
          // Trigger search log even if assigned
          shopApi
            .updateContact({
              _id: checkExist.data[0]._id,
              isSearchPhone: true,
              staffName: user.name,
              phone: contact.phoneNumber,
              shopId: shop._id,
            })
            .catch(() => {});
          setNewContact(checkExist.data[0]);
        }
        setPhoneNumber("");
        setShowProfile(false);
        setIsOpen(false);
      }
    } catch (error) {
      addNotification("Có lôi xảy ra: " + error.message, -1);
    }
  };

  useEffect(() => {
    if (isOpen) {
      phoneInpRef?.current?.focus();
    }
  }, [isOpen]);

  return (
    <div
      className={`fixed inset-0 bg-black/50 flex items-start justify-center text-black z-20 ${
        isOpen ? "" : "hidden"
      }`}
    >
      <div className="bg-white w-full max-w-md mt-4 rounded-lg overflow-hidden">
        {!showProfile ? (
          <>
            {/* Search Modal */}
            <div className="flex items-center justify-between p-4 border-b">
              <h2 className="text-lg font-medium">Thêm bạn</h2>
              <button
                onClick={() => {
                  setPhoneNumber("");
                  setShowProfile(false);
                  setIsOpen(false);
                }}
                className="p-1 hover:bg-gray-100 rounded-full"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="p-4">
              <div className="flex gap-2 mb-4">
                <button className="flex items-center gap-1 px-2 py-1.5 border rounded-md">
                  <span>(+84)</span>
                </button>

                <input
                  type="tel"
                  placeholder="Số điện thoại"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  className="flex-1 px-3 py-1.5 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  ref={phoneInpRef}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault(); // Ngăn việc xuống dòng tự động
                      handleSearch();
                    }
                  }}
                />
              </div>

              <p className="text-gray-500 text-center py-8">
                Không có tìm kiếm nào gần đây
              </p>
            </div>

            <div className="flex gap-3 p-4 border-t">
              <button
                onClick={() => {
                  setPhoneNumber("");
                  setShowProfile(false);
                  setIsOpen(false);
                }}
                className="flex-1 px-4 py-2 border rounded-md hover:bg-gray-50 text-black"
              >
                Hủy
              </button>
              <button
                onClick={handleSearch}
                className="flex-1 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 flex items-center justify-center"
                disabled={isLoading}
              >
                {isLoading && (
                  <LoaderCircle
                    className="animate-spin text-white mr-2"
                    width={20}
                    height={20}
                  />
                )}
                Tìm kiếm
              </button>
            </div>
          </>
        ) : (
          <>
            {/* Profile View */}
            <div className="relative">
              {/* Banner Image */}
              <div className="h-48 bg-gray-200">
                <img
                  src={contact?.cover}
                  alt="Banner"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Close Button */}
              <button
                onClick={() => setShowProfile(false)}
                className="absolute top-4 right-4 p-1 bg-black/50 hover:bg-black/70 rounded-full"
              >
                <X className="w-5 h-5 text-white" />
              </button>

              {/* Profile Image */}
              <div className="absolute left-4 -bottom-10">
                <div className="w-20 h-20 rounded-full border-4 border-white overflow-hidden">
                  <img
                    src={contact?.avatar}
                    alt="Profile"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            {/* Profile Content */}
            <div className="pt-12 px-4">
              <div className="flex items-center gap-2 mb-4">
                <h2 className="text-2xl font-semibold">
                  {contact?.displayName}
                </h2>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3 mb-6">
                {!contact?.isFr && (
                  <button
                    className="flex-1 py-2 bg-gray-100 hover:bg-gray-200 rounded-md font-medium"
                    onClick={() => setIsOpenAddFriendModal(true)}
                  >
                    Kết bạn
                  </button>
                )}
                <button
                  className="flex-1 py-2 bg-blue-500 text-white hover:bg-blue-600 rounded-md font-medium"
                  onClick={handleMessageClick}
                >
                  Nhắn tin
                </button>
              </div>

              {/* Personal Information */}
              <div className="border-t py-4">
                <h3 className="text-lg font-medium mb-4">Thông tin cá nhân</h3>
                <div className="space-y-3">
                  <div className="flex">
                    <span className="w-24 text-gray-500">Giới tính</span>
                    <span className="flex-1">
                      {contact?.gender === 1 ? "Nữ" : "Nam"}
                    </span>
                  </div>
                  <div className="flex">
                    <span className="w-24 text-gray-500">Ngày sinh</span>
                    <span className="flex-1">
                      {contact?.sdob ? contact?.sdob : "**/**/****"}
                    </span>
                  </div>
                  <div className="flex">
                    <span className="w-24 text-gray-500">Bio</span>
                    <span className="flex-1">{contact?.status}</span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <AddFriendModal
        isOpen={isOpenAddFriendModal}
        setIsOpen={setIsOpenAddFriendModal}
        shop={shop}
        addFriend={handleAddFriendClick}
      />
    </div>
  );
}
